"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    container: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(14),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: theme.typography.fontWeightMedium,
      padding: theme.spacing(0.9, 1),
      borderRadius: 4,
      display: 'inline-flex'
    },
    standard: {
      backgroundColor: theme.palette.NEUTRAL020,
      color: theme.palette.NEUTRAL700
    },
    blue: {
      backgroundColor: theme.palette.BLUE050,
      color: theme.palette.BLUE400
    },
    green: {
      backgroundColor: theme.palette.GREEN050,
      color: theme.palette.GREEN400
    },
    red: {
      backgroundColor: theme.palette.RED050,
      color: theme.palette.RED400
    },
    orange: {
      backgroundColor: theme.palette.YELLOW075,
      color: theme.palette.RED300
    },
    purple: {
      backgroundColor: theme.palette.PURPLE050,
      color: theme.palette.PURPLE300
    }
  });
});
var _default = useStyles;
exports.default = _default;